import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Text from '../../../../shared/Text';
import { SplitPillButton } from '../../../../shared/Button/SplitPillButton.jsx';
import useSort from '../../../../shared/Sort/useSort';

import PrizeModal from './PrizeModal.jsx';

import { DRAFT, FINISHED, PICKED } from '../../utils/constants';
import { useGetPrize } from './data/data';
import { NoPrize } from './NoPrize.jsx';
import { Winners } from './Winners.jsx';

import {
  setOpenPrizeModal,
  unSetOpenPrizeModal,
} from '../../../../lib/redux/campaignPrize/campaignPrizeSlice';

export const Prizes = ({ campaign, nextStep }) => {
  const { t } = useTranslation('campaigns');
  const dispatch = useDispatch();
  const { sortingStatus, changeSort } = useSort();
  const isDisabled = campaign.isArchived || !!campaign.deletedAt;
  const prize = useGetPrize({ ...sortingStatus, campaignUuid: campaign.uuid });
  const openPrizeModal = useSelector(
    state => state.campaignPrize.openPrizeModal,
  );
  const finishedPrize = prize.status === FINISHED || prize.status === PICKED;

  return (
    <PrizeContainer>
      <PrizeModal
        prize={campaign.prize}
        modalOpen={openPrizeModal}
        closeModal={() => dispatch(unSetOpenPrizeModal())}
      />
      {prize.id ? (
        <>
          {prize.status !== DRAFT && (
            <Text variant="subtitle2" opacity="0.4">
              {t(`prizes.statusNote.${prize.status}`)}
            </Text>
          )}

          <SplitPillButton
            iconClass={'fa-light fa-gift'}
            leftText={'Prizes'}
            rightText={t(`prizes.statuses.${prize.status}`)}
            onClick={() => dispatch(setOpenPrizeModal())}
            disabled={isDisabled}
          />

          {finishedPrize && (
            <Winners
              prize={prize}
              sortingStatus={sortingStatus}
              changeSort={changeSort}
            />
          )}
        </>
      ) : (
        <NoPrize
          nextStep={nextStep}
          openPrizeModal={() => dispatch(setOpenPrizeModal())}
        />
      )}
    </PrizeContainer>
  );
};

const PrizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 20px;
`;
